import CustomCarousel from "./CustomCarousel";

export default CustomCarousel;
